export default {
  name: 'lab_sel',
  props: {
    labId: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      pageConfig: {
        queryFunName: 'labAreaQuery'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: this.searchKey,
        labId: this.labId,
        category: this.category,
        sortField: '^sort'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      categoryObj: {
        Park: {
          label: '园区',
          icon: require('@/assets/org/Park.png')
        },
        Factory: {
          label: '厂房',
          icon: require('@/assets/org/Factory.png')
        },
        Cistern: {
          label: '养殖池',
          icon: require('@/assets/org/Cistern.png')
        },
        Pond: {
          label: '池塘',
          icon: require('@/assets/org/Pond.png')
        },
        Lake: {
          label: '湖',
          icon: require('@/assets/org/Lake.png')
        },
        Ground: {
          label: '地块',
          icon: require('@/assets/org/Ground.png')
        }
      }
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    sel: function sel(data) {
      this.$emit('child-area-sel', data);
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^sort';
      this.query();
    }
  }
};